import React from 'react'

import RequestDetailsForm from './request_details_form.jsx'

let RequestDetailsRouter = ({ location }) => ( // this doesn't have any nested routes to worry about, so we punt
  <RequestDetailsForm scrollToLineItemsOnMount={ location.state && location.state.fromReviewLineItemError } />
)

export default RequestDetailsRouter
